// ClientOS closed for maintenance: the API says so (503 platform.maintenance), and from then
// on the app shows why instead of its pages, until it opens again (MaintenanceGate).
let closed = false;
const listeners = new Set<() => void>();

export const maintenance = {
  closed: () => closed,
  close() {
    if (closed) return;
    closed = true;
    listeners.forEach((l) => l());
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => void listeners.delete(l);
  },
};
